import ThirdToFullGrid from './ThirdToFullGrid'

export default ThirdToFullGrid
